import Accordion from "@/components/Accordion";
import { Button } from "@/components/Button";
import { useGetShopifyIntegration } from "@/requests/hooks/collect";
import { SHOPIFY_CHECKOUT_SETTINGS_URL } from "@/utils/const";
import { faCaretRight } from "@fortawesome/pro-duotone-svg-icons";
import { Trans, useTranslation } from "react-i18next";
import disableShopifyConsent from "@/assets/videos/collect/onboarding/disable-shopify-consent.mp4";
import OnboardingVideo from "@/components/OnboardingVideo";
import { useOnboardingStatus } from "@/hooks/useOnboardingStatus";
import { OnboardingProgression } from "@/components/OnboardingProgression";
import { Bold, H3, P } from "@/components/Typography";

const DisableCheckout = () => {
  const { t } = useTranslation();
  const { data: shopifyIntegrationData } = useGetShopifyIntegration();
  const {
    onboardingStatus: { isOnboarding },
  } = useOnboardingStatus();

  const renderHeading = () => (
    <div className="max-w-md mb-20">
      <div className="mb-10">
        <H3 className="font-bold">
          {t("integrations.shopSettings.disableCheckout.header.heading")}
        </H3>
      </div>
      <P>{t("integrations.shopSettings.disableCheckout.header.description")}</P>
    </div>
  );

  const renderDescriptionText = () => (
    <ol className="flex list-decimal flex-col gap-10 ps-20 text-start text-primary-dark">
      <li>
        <Trans i18nKey="integrations.shopSettings.disableCheckout.instructions.step1">
          zero
          <Button
            as="a"
            variant="link"
            icon={faCaretRight}
            iconPosition="end"
            iconClassName="text-secondary"
            href={
              shopifyIntegrationData?.shopifyCheckoutSettingsUrl ||
              SHOPIFY_CHECKOUT_SETTINGS_URL
            }
            testId="checkout-settings-link">
            one
          </Button>
        </Trans>
      </li>
      <li>
        <Trans i18nKey="integrations.shopSettings.disableCheckout.instructions.step2">
          zero
          <span className="font-bold">one</span>
          two
          <span className="font-bold">three</span>
          four
          <span className="font-bold">five</span>
        </Trans>
      </li>
      <li>
        <Trans i18nKey="integrations.shopSettings.disableCheckout.instructions.step3">
          zero
          <span className="font-bold">one</span>
          two
          <span className="font-bold">three</span>
        </Trans>
      </li>
    </ol>
  );

  const renderVideo = () => (
    <OnboardingVideo videoLocation={disableShopifyConsent} />
  );

  const renderAccordion = () => (
    <Accordion
      defaultIsExpanded={true}
      topContent={
        <Bold>{t("integrations.shopSettings.disableCheckout.title")}</Bold>
      }>
      <div className="flex flex-row gap-30">
        <div className="w-7/12">{renderDescriptionText()}</div>
        <div className="w-5/12 flex-shrink-0">{renderVideo()}</div>
      </div>
    </Accordion>
  );

  const renderOnboardingProgression = () =>
    !!isOnboarding && (
      <div className="my-50">
        <OnboardingProgression
          currentStep="CONFIGURE_CHECKOUT"
          enabled={true}
        />
      </div>
    );

  return (
    <>
      {renderHeading()}
      {renderAccordion()}
      {renderOnboardingProgression()}
    </>
  );
};

export default DisableCheckout;
